import OrderModel from "./OrderModel";

export default class OrderItemSelectionDemandModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date();
			this.partNumber = data.partNumber;
			this.demand = data.demand ?? '';
			this.oemOnly = data.oemOnly;
			
			if (data.order?.id) {
				this.order = new OrderModel(data.order);
			}
		}
	}

	id = 0;
	date = new Date();
	partNumber: string | null = null;
	demand = '';   
	oemOnly: boolean | null = null;
	order: OrderModel | null = null;
}